export const colors = {
  theme: '#FF9900',
  btnBg: '#FFDE00',
  btnHoverBg: '#8db2d8',
  btnHoverColor: '#ffffff',
};
